import React from 'react';
import PropTypes from 'prop-types';
import { graphql, Link } from 'gatsby';

import { LocaleProvider } from '../context/localeContext';
import BlogRollPaginated from '../components/BlogRollPaginated';
import Layout from '../components/Layout';
import Section from '../components/Section';

const TagPageTemplate = ({ data, pageContext }) => {
  const { edges: blogPosts } = data.blogPosts;
  const { tag } = pageContext;

  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <Section colorScheme="white">
          <div className="container pt-24 pb-6">
            <h1 className="text-4xl font-bold mb-4">Posts tagged &ldquo;{tag}&rdquo;</h1>
            <nav className="text-sm">
              <Link to="/blog" className="text-primary hover:underline">
                Blog
              </Link>
              <span className="mx-2">{'>'}</span>
              <span>{tag}</span>
            </nav>
          </div>
        </Section>
        <BlogRollPaginated items={blogPosts} />
      </Layout>
    </LocaleProvider>
  );
};

TagPageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default TagPageTemplate;

export const tagPageQuery = graphql`
  query TagPage($tag: String!, $locale: String!) {
    blogPosts: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: {
        fields: { collection: { eq: "blog-posts" }, locale: { eq: $locale } }
        frontmatter: { title: { ne: "" }, tags: { in: [$tag] } }
        rawMarkdownBody: { ne: "" }
      }
    ) {
      edges {
        node {
          ...BlogRollItem
        }
      }
    }
  }
`;
